<section>
    <div id="spinner" class="spinner-overlay">
        <div class="spinner"></div>
    </div>

    <p>Carregando</p>
</section>